import { FC, MouseEvent, useCallback, useState } from 'react';
import { TabsNavigation } from 'components';
import { FirmPendingDecisions, NoCompanyMessage, NoInformationMessage } from 'pages/Firms/components';
import { useFirmSummaryTab } from 'pages/Firms/hooks';

const FirmSummary: FC = () => {
  // Create firm summary tab
  const { firmSummaryTab, hasNoCompanies, hasNoInvestments } = useFirmSummaryTab();
  const [currentTabMenu, setCurrentTabMenu] = useState<HTMLSpanElement | null>(null);

  const handleMenuClose = useCallback(() => setCurrentTabMenu(null), []);
  const handleMenuOpen = useCallback(
    (event: MouseEvent<HTMLSpanElement>) => setCurrentTabMenu(event.currentTarget),
    []
  );

  return (
    <TabsNavigation
      handleMenuClose={handleMenuClose}
      handleMenuOpen={handleMenuOpen}
      menuAnchorEl={currentTabMenu}
      mountOnActive
      tabs={[firmSummaryTab]}
      updateUrlOnTabChange>
      {/* Pending decisions */}
      <FirmPendingDecisions />

      {/* Add company message */}
      {hasNoCompanies && <NoCompanyMessage />}

      {/* Add investment message */}
      {!hasNoCompanies && hasNoInvestments && <NoInformationMessage />}
    </TabsNavigation>
  );
};

export default FirmSummary;
